import React, { useContext, useState } from "react";
import TimeTableContext from "../../context/timeTableContext";

import SwipeableViews from "react-swipeable-views";

import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";

import PressTable from "./weeklyParts/PressTable";
import FrontLessons from "./weeklyParts/FrontLessons";
import FreeTeachers from "./weeklyParts/FreeTeachers";
import Rooms from "./weeklyParts/Rooms";
import AvailbleTeachers from "./weeklyParts/AvailbleTeachers";
import CirclePlus from "./weeklyParts/CirclePlus";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";

import "./WeeklyTime.css";

const WeeklyTime = () => {
  const context = useContext(TimeTableContext);

  const [value, setValue] = useState(0);
  const tabMovePress = (event, newValue) => {
    setValue(newValue);
  };

  const tabMoveSlide = (index) => {
    setValue(index);
  };
  return (
    <div>
      <PressTable />
      <div
        className={`info-holder  ${
          context.state.openDeck ? "info-holder-open" : "info-holder-close"
        }`}
      >
        <CirclePlus />
        <AppBar position="static">
          <Tabs value={value} onChange={tabMovePress} aria-label="">
            <Tab label="פרונטלי/העשרה" />
            <Tab label="צוות/שהיה/פרטני" />
            <Tab label="העדרות" />
            <Tab label="חדרים" />
          </Tabs>
        </AppBar>
        <SwipeableViews
          axis="x-reverse"
          index={value}
          onChangeIndex={tabMoveSlide}
          style={{ direction: "rtl" }}
        >
          <TabPanel value={value} index={0}>
            <FrontLessons />
          </TabPanel>
          <TabPanel value={value} index={1}>
            <AvailbleTeachers />
          </TabPanel>
          <TabPanel value={value} index={2}>
            <FreeTeachers />
          </TabPanel>
          <TabPanel value={value} index={3}>
            <Rooms />
          </TabPanel>
        </SwipeableViews>
      </div>
    </div>
  );
};

export default WeeklyTime;

function TabPanel(props) {
  const { value, index } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{props.children}</Typography>
        </Box>
      )}
    </div>
  );
}
